import { defineComponent, computed, inject } from 'vue';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertBadge",
  props: {
    locale: { type: null, required: false, default: "en-GB" },
    lastCheck: { type: Date, required: true },
    maxAlerts: { type: Number, required: false, default: 150 },
    maxDisplayedAlerts: { type: Number, required: false, default: 99 }
  },
  emits: ["store-error", "data-load"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const componentInputs = computed(() => ({
      lastCheck: props.lastCheck,
      maxAlerts: props.maxAlerts
    }));
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator")
    });
    const { textFormat } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, isLoadingStoreData } = storeModule;
    const alerts = computed(() => {
      var _a, _b;
      return (_b = (_a = storeData.value) == null ? void 0 : _a.alerts) != null ? _b : null;
    });
    const hasData = computed(() => alerts.value !== null);
    const isEmpty = computed(() => alerts.value === 0);
    const isOverMaxAlerts = computed(() => {
      var _a;
      return ((_a = alerts.value) != null ? _a : 0) > props.maxDisplayedAlerts;
    });
    const totalAlerts = computed(() => {
      if (!hasData.value)
        return null;
      return isOverMaxAlerts.value ? `${props.maxDisplayedAlerts}+` : String(alerts.value);
    });
    return { __sfc: true, props, emits, componentInputs, localizationSupport, textFormat, storeModule, storeData, isLoadingStoreData, alerts, hasData, isEmpty, isOverMaxAlerts, totalAlerts };
  }
});

export { _sfc_main as default };
